import debug from 'debug';

const logger = debug('sdi:map/singleclick');

import Map from 'ol/Map';

import { withInteraction } from '../functions';
import { SingleClickOptions } from '../types';

export const singleclick = ({ setPosition }: SingleClickOptions) => {
    let isActive = false;

    const update = withInteraction(
        'singleclick',
        () => {
            isActive = true;
        },
        () => {
            isActive = false;
        },
    );

    const init = (map: Map) => {
        map.on('singleclick', event => {
            logger(`hit ${isActive}`);
            setPosition(event.coordinate, isActive);
        });
    };

    return { init, update };
};

logger('loaded');
